import moment from 'moment';

export const FORMAT_DATE_DEFAULT = 'YYYY-MM-DD';
export const FORMAT_DATE_TIME_DEFAULT = 'YYYY-MM-DDTHH:mm:ss';
export const FORMAT_TIME_DEFAULT = 'HH:mm';

const formatDateRequest = (data) => moment(data).format(FORMAT_DATE_DEFAULT);
const formatTimeRequest = (data) => moment(data).format(FORMAT_TIME_DEFAULT);

export const toDate = (data, format = FORMAT_DATE_DEFAULT) => moment(data, format).toDate();
export const toTime = (data, format = FORMAT_TIME_DEFAULT) => moment(data, format).toDate();
// eslint-disable-next-line max-len
export const toDateTime = (data, format = FORMAT_DATE_TIME_DEFAULT) => moment(data, format).toDate();

const formatdate = function v(cellValue) {
  if (cellValue === null || cellValue === undefined || cellValue === '') {
    return cellValue;
  }
  moment.locale('pt-br');
  return moment(cellValue).format('DD/MM/YYYY');
};

const formatmesano = function v(cellValue) {
  if (cellValue === null || cellValue === undefined || cellValue === '') {
    return cellValue;
  }
  moment.locale('pt-br');
  return moment(cellValue).format('MM/YYYY');
};

const formatano = function v(cellValue) {
  if (cellValue === null || cellValue === undefined || cellValue === '') {
    return cellValue;
  }
  moment.locale('pt-br');
  return moment(cellValue).format('YYYY');
};

const formatdatacompleta = function v(cellValue) {
  if (cellValue === null || cellValue === undefined || cellValue === '') {
    return cellValue;
  }
  moment.locale('pt-br');
  return moment(cellValue).format('DD/MM/YYYY HH:mm:ss');
};

const formattime = function v(cellValue) {
  if (cellValue === null || cellValue === undefined || cellValue === '') {
    return cellValue;
  }
  moment.locale('pt-br');
  return moment(cellValue).format('HH:mm');
};

const formatdatahoraparam = function v(cellValue, formato) {
  if (cellValue === null || cellValue === undefined || cellValue === '') {
    return cellValue;
  }
  moment.locale('pt-br');
  return moment(cellValue, formato).format('DD/MM/YYYY HH:mm:ss');
};

export {
  formatdate, formatmesano, formatano, formatdatacompleta, formattime, formatdatahoraparam,
  formatDateRequest, formatTimeRequest,
};
